import * as Three from 'three'

class ThreeJsRenderer {
    canvas;
    renderer;

    constructor() {
        this.canvas = document.createElement('canvas');
        this.renderer = new Three.WebGLRenderer({canvas: this.canvas, alpha: true, antialias: true});

        return this;
    }

    start() {
        console.error('you might want to override start method')
    }

    getCanvas() {
        return this.canvas;
    }

    resizeRendererToDisplaySize() {
        const pixelRatio = window.devicePixelRatio;
        const width  = this.canvas.clientWidth  * pixelRatio | 0;
        const height = this.canvas.clientHeight * pixelRatio | 0;
        const needResize = this.canvas.width !== width || this.canvas.height !== height;
        if (needResize) {
            // this.renderer.setSize(1000, 1000, false);
            // this.renderer.setSize(width, height, false);
        }
        return needResize;
    }

}

export default ThreeJsRenderer;
